import { atom } from 'jotai';

import { IResponseValidateHTML } from '@/modules/CampaignsModule/interfaces/HTMLEditor';

export interface IModalValidateData {
  line: number;
  column: number;
  message: string;
  offset: number;
  selector: string;
  tag: string;
}

export const modalValidateAtom = atom<boolean>(false);

export const modalValidateDataAtom = atom<IResponseValidateHTML>({
  errors: [],
  warnings: [],
});
